/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-04-23 09:58:19
 * @LastEditors: limin
 * @LastEditTime: 2021-04-23 15:44:45
 */
export const fetchConfig = function(){
    return window.fetch('https://oss-config.test.glsx.com.cn/mock/5be17454f31545347559d499/config/dijia-h5-mall-config', {})
    .then(res => res.json())
}
export const config = {
  install(vue,config) {
     vue.prototype.$config = config
  }
};
